import { Box, Stack } from "@mui/system";

import VerticalLinearStepper from "../VerticalLinearStepper";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";

import { RecapCard } from "../../RecapCard";
import { CodeBlock, dracula } from "react-code-blocks";

export const IttechDatabasesQueryRecap = () => {
  const recapBlocks = [
    {
      label: "De 'Identity' kolom",
      main: "Wat is het belang van een Identity kolom?",
      image: "presentation-data/ITTECH2/sql/identity_gap.png",
      reveal:
        "Het zorgt ervoor dat elk record automatisch een uniek nummer krijgt. Hierdoor voorkom je dubbele rijen en heb je altijd een betrouwbare Primary Key",
    },
    {
      label: "De Wildcard",
      image: "presentation-data/ITTECH2/sql/gamescores.png",
      main: (
        <>
          Welke query haalt álle kolommen op uit de tabel met gamescores?
          <br />
          <br />
          <CodeBlock
            language="sql"
            theme={dracula}
            text={`SELECT ... FROM GameScores;`}
          />
        </>
      ),
      reveal: (
        <CodeBlock
          language="sql"
          theme={dracula}
          text={`SELECT * FROM GameScores;`}
        />
      ),
    },
    {
      label: "Filteren op Platform",
      image: "presentation-data/ITTECH2/sql/gamescores.png",
      main: (
        <>
          Hoe maak je deze query af om alleen de 'PC' spelers te zien?
          <br />
          <br />
          <CodeBlock
            language="sql"
            theme={dracula}
            text={`SELECT SpelerNaam FROM GameScores`}
          />
        </>
      ),
      reveal: (
        <CodeBlock
          language="sql"
          theme={dracula}
          text={`SELECT SpelerNaam FROM GameScores WHERE Platform = 'PC';`}
        />
      ),
    },
    {
      label: "Wat is een .bak bestand?",
      main: "Je hebt AdventureWorks gedownload. Welke actie moet je uitvoeren om deze in SSMS te krijgen?",
      reveal: (
        <>
          Je moet een 'Restore Database' uitvoeren om de back-up terug te
          zetten.
          <img
            src="/presentation-data/ITTECH2/sql/restore.png"
            width="70%"
            style={{
              margin: "auto",
              display: "block",
              boxShadow: "0 0 10px #CCC",
              borderRadius: "10px",
            }}
            alt="Opdracht 1"
          />
        </>
      ),
    },
    {
      label: "Alleen unieke namen",
      image: "presentation-data/ITTECH2/sql/gamescores.png",
      main: "Ik wil een lijst met alle SpelerNamen, maar ik wil elke naam maar één keer zien. Welke query gebruik ik?",
      reveal: (
        <CodeBlock
          language="sql"
          theme={dracula}
          text={`SELECT DISTINCT SpelerNaam FROM GameScores;`}
        />
      ),
    },
    {
      label: "De Top 3",
      image: "presentation-data/ITTECH2/sql/gamescores.png",
      main: "Hoe toon ik alleen de 3 rijen met de hoogste scores?",
      reveal: (
        <CodeBlock
          language="sql"
          theme={dracula}
          text={`SELECT TOP 3 * FROM GameScores ORDER BY Score DESC;`}
        />
      ),
    },
    {
      label: "Sorteren op Datum",
      main: "Hoe sorteer je de resultaten van oud naar nieuw?",
      image: "presentation-data/ITTECH2/sql/gamescores.png",
      reveal: (
        <CodeBlock
          language="sql"
          theme={dracula}
          text={`SELECT * FROM GameScores ORDER BY DatumScore ASC;`}
        />
      ),
    },
    {
      label: "Zoeken met Wildcards",
      main: "Hoe vind je alle games die beginnen met de letter 'F'?",
      image: "presentation-data/ITTECH2/sql/gamescores.png",
      reveal: (
        <CodeBlock
          language="sql"
          theme={dracula}
          text={`SELECT * FROM GameScores WHERE GameNaam LIKE 'F%';`}
        />
      ),
    },
    {
      label: "Waar staat CRUD voor?",
      image: "presentation-data/ITTECH2/sql/crud.png",
      reveal: (
        <>
          CREATE - RETRIEVE / READ - UPDATE - DELETE
          <img
            src="/presentation-data/ITTECH2/sql/crud-reveal.jpeg"
            width="70%"
            style={{
              margin: "auto",
              display: "block",
              boxShadow: "0 0 10px #CCC",
              borderRadius: "10px",
            }}
            alt="Opdracht 1"
          />
        </>
      ),
    },
  ];

  return (
    <VerticalLinearStepper
      steps={[
        {
          label: "🧠 Recap",
          description: ``,
          content: (
            <Stack alignItems="center">
              <Box
                sx={{
                  width: "100%",
                  "& .swiper-slide:not(.swiper-slide-active)": {
                    filter: "blur(15px)",
                  },
                  "& .swiper-slide-active,": { filter: "none" },
                }}
              >
                <Swiper
                  effect={"coverflow"}
                  grabCursor={true}
                  centeredSlides={true}
                  slidesPerView={2}
                  loop={true}
                  coverflowEffect={{
                    rotate: 20,
                    stretch: 110,
                    depth: 150,
                    modifier: 1.2,
                    slideShadows: false,
                    scale: 0.8,
                  }}
                  pagination={true}
                  navigation={true}
                  modules={[EffectCoverflow, Pagination, Navigation]}
                >
                  {recapBlocks.map((x) => (
                    <SwiperSlide>
                      <Box p={1}>
                        <RecapCard key={x.label} subject={x} />
                      </Box>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </Box>
            </Stack>
          ),
        },
        {
          label: "INSERT (CREATE)",
          description: `Een nieuw record toevoegen aan de tabel. Let op dat de volgorde van kolommen en waarden gelijk moet zijn.`,
          content: (
            <CodeBlock
              language="sql"
              theme={dracula}
              text={`INSERT INTO GameScores (SpelerNaam, Leeftijd, GameNaam, Platform, Score, DatumScore)\nVALUES ('Pietje Puk', 19, 'Minecraft', 'PC', 450, '2025-10-25');`}
            />
          ),
        },
        {
          label: "UPDATE",
          description: `Bestaande gegevens wijzigen. Vergeet NOOIT de WHERE clausule, anders pas je iedereen aan!`,
          content: (
            <CodeBlock
              language="sql"
              theme={dracula}
              text={`UPDATE GameScores \nSET Score = 550 \nWHERE SpelerNaam = 'Pietje Puk' AND GameNaam = 'Minecraft';`}
            />
          ),
        },
        {
          label: "DELETE",
          description: `Een record definitief verwijderen. Ook hier is de WHERE essentieel om te voorkomen dat je de hele tabel leeggooit.`,
          content: (
            <CodeBlock
              language="sql"
              theme={dracula}
              text={`DELETE FROM GameScores \nWHERE ID = 11;`}
            />
          ),
        },
      ]}
    />
  );
};
